(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7694],{

/***/ 9878:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/png-to-pdf",
      function () {
        return __webpack_require__(26408);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 3224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24599);





const PdfToolsLinks = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-center text-2xl md:text-4xl text-gray-800 mb-10",
                children: "Other PDF tools offered by BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-[1280px] mx-auto flex justify-center items-center flex-wrap gap-4",
                children: _constants_signature__WEBPACK_IMPORTED_MODULE_4__/* .signatureTools.map */ .kn.map((tool, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: tool.url,
                        className: "w-[220px] h-[80px] bg-white border rounded-xl drop-shadow-md px-4 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105 z-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full grid place-items-center text-xl text-gray-600",
                            children: tool.title
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PdfToolsLinks);


/***/ }),

/***/ 26408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _react_pdf_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32492);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8193);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(89583);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56130);
/* harmony import */ var _components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86318);
/* harmony import */ var _components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3224);
/* harmony import */ var _components_PdfTools_UploadFile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86297);
/* harmony import */ var _components_PdfTools_Steps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2561);
/* harmony import */ var _components_PdfTools_WhyChooseBolosign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80383);
/* harmony import */ var _components_PdfTools_PricingCards__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23278);
/* harmony import */ var _components_PdfTools_TryBolosign__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86658);
/* harmony import */ var _components_PdfTools_OtherPdfTools__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41441);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86585);
/* harmony import */ var react_icons_lu__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1451);
/* harmony import */ var react_icons_gr__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45155);






















const steps = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_15__/* .LuUpload */ .oSY, {}),
        title: "Upload Your PNG",
        description: "Drag and drop your PNG file into the area above or click 'Select File' to choose the file from your device. Our platform supports all the conversions from PNG to PDF, making your tasks simpler."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_gr__WEBPACK_IMPORTED_MODULE_16__/* .GrDocumentPdf */ .cdp, {}),
        title: "Redefine Your PDF",
        description: "Use our customizable settings to adjust the output of your PDF. Need to change a PNG to a PDF? No problem! Adjust image quality, orientation, and margins to fit your needs."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_15__/* .LuDownload */ .$0x, {}),
        title: "Download Your PDF",
        description: "After converting your PNG into a PDF, click 'Download' to save your new PDF file. It's that simple! Your new PDF will be ready to use for any personal or professional purpose."
    }
];
const reasons = [
    {
        image: "no_signup_required.png",
        title: "No Signup Required",
        description: "Convert your files without the need to create an account. Start your PNG to PDF conversion right away."
    },
    {
        image: "three_quick_steps.png",
        title: "Three Quick Steps",
        description: 'All you need to do is upload your file, make any desired adjustments, and click "Apply and download" to merge PNGs into a PDF.'
    },
    {
        image: "cloud_hosted.png",
        title: "Cloud-Hosted",
        description: "Our tools are cloud-hosted, ensuring you have access anytime and anywhere without using up your device's resources."
    },
    {
        image: "file_deletion.png",
        title: "File Deletion Policy",
        description: "We prioritize your privacy. All uploaded files are automatically deleted after conversion."
    }
];
const faqData = [
    {
        faqQuestion: "How do I convert a PNG to a PDF?",
        faqAnswer: "To convert a PNG to PDF, simply upload your PNG file using our tool. Adjust the settings as needed, and then download your converted PDF. Our tool supports all variations of PNG to PDF conversions, providing a seamless experience."
    },
    {
        faqQuestion: "Can I convert multiple PNG files to PDF at once?",
        faqAnswer: "Yes, our tool allows you to convert multiple PNG files to PDF simultaneously. Just select all the PNGs you want to convert, and our system will combine them into a single PDF document or create individual PDF files based on your preference."
    },
    {
        faqQuestion: "What is the best way to convert from PNG to PDF?",
        faqAnswer: "The best way to convert from PNG to PDF is to use a reliable online converter like BoloSign that maintains the quality of your original image while ensuring the PDF output meets your needs. Adjustments such as image quality and document orientation can be made directly within our tool."
    }
];
const PAGE_SIZES = [
    "4A0",
    "2A0",
    "A0",
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "A10",
    "B0",
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "B10",
    "C0",
    "C1",
    "C2",
    "C3",
    "C4",
    "C5",
    "C6",
    "C7",
    "C8",
    "C9",
    "C10",
    "RA0",
    "RA1",
    "RA2",
    "RA3",
    "RA4",
    "SRA0",
    "SRA1",
    "SRA2",
    "SRA3",
    "SRA4",
    "EXECUTIVE",
    "FOLIO",
    "LEGAL",
    "LETTER",
    "TABLOID",
    "ID1"
];
const DocumentPdf = (param)=>{
    let { images =[] , pageSize , orientation , imageAlignment  } = param;
    const pdfStyles = _react_pdf_renderer__WEBPACK_IMPORTED_MODULE_2__/* .StyleSheet.create */ .mM.create({
        viewer: {
            width: "1000px",
            height: "1000px"
        },
        page: {
            backgroundColor: "#ffffff",
            color: "#000000",
            display: "flex",
            justifyContent: imageAlignment,
            alignItems: "center"
        },
        image: {
            width: "100%",
            height: "auto"
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_pdf_renderer__WEBPACK_IMPORTED_MODULE_2__/* .Document */ .BB, {
        children: images.map((image, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_pdf_renderer__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
                size: pageSize,
                style: pdfStyles.page,
                orientation: orientation,
                wrap: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_pdf_renderer__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: image,
                    style: pdfStyles.image,
                    alt: ""
                })
            }, index))
    });
};
const PngToPdf = ()=>{
    const [images, setImages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pageRendering, setPageRendering] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pageSize, setPageSize] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("A4");
    const [orientation, setOrientation] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("portrait");
    const [imageAlignment, setImageAlignment] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("center");
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollToPreview = ()=>{
        const element = document.querySelector(".preview-pdfs");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        const files = e.dataTransfer.files;
        handleImageUpload(files);
        scrollToPreview();
    };
    const handleUpload = (e)=>{
        const files = e.target.files;
        handleImageUpload(files);
        if (files) {
            scrollToPreview();
        }
    };
    const handleFileUpload = (files)=>{
        handleImageUpload(files);
        scrollToPreview();
    };
    const handleImageUpload = (files)=>{
        // const files = event.target.files;
        setPageRendering(true);
        const imageArray = [];
        for(let i = 0; i < files.length; i++){
            const reader = new FileReader();
            reader.onloadend = ()=>{
                imageArray.push(reader.result);
                if (imageArray.length === files.length) {
                    setImages([
                        ...images,
                        ...imageArray
                    ]);
                }
            };
            reader.readAsDataURL(files[i]);
        }
        setPageRendering(false);
    };
    const handleDownload = async ()=>{
        setLoader(true);
        const doc = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DocumentPdf, {
            images: images,
            pageSize: pageSize,
            orientation: orientation,
            imageAlignment: imageAlignment
        });
        const asPdf = (0,_react_pdf_renderer__WEBPACK_IMPORTED_MODULE_2__/* .pdf */ .eA)([]);
        asPdf.updateContainer(doc);
        const blob = await asPdf.toBlob();
        (0,file_saver__WEBPACK_IMPORTED_MODULE_3__.saveAs)(blob, "document.pdf");
        setLoader(false);
        setTimeout(()=>{
            setSignaturePopup(true);
        }, 2000);
    };
    const removeImage = (index)=>{
        const newImages = [
            ...images
        ];
        newImages.splice(index, 1);
        setImages(newImages);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mt-20 sm:mt-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "PNG to PDF Tool | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Convert PNG images to PDF documents online for free. No software installation required."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "png to pdf, png to pdf converter, convert png to pdf, png to pdf online, png to pdf free, png to pdf tool, png to pdf conversion, png to pdf converter online, png to pdf converter free, png to pdf converter tool, image to pdf, image to pdf converter, convert image to pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/png-to-pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "PNG to PDF Tool | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Convert PNG images to PDF documents online for free. No software installation required."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/pdf-tools/png-to-pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en_US"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "PNG to PDF Tool | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Convert PNG images to PDF documents online for free. No software installation required."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/png-to-pdf/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_UploadFile__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        heading: "Convert Your PNG to PDF Effortlessly with BoloSign",
                        description: "Do you need to convert PNG to PDF online? Whether for business or personal use, our BoloSign converter allows you to seamlessly transform your PNG files into PDFs. Get started now and convert your images to PDF in a few easy steps. No software installation is needed—access the tool directly from your browser.",
                        bgColor: "bg-[#d5f6d5]",
                        btnColor: "bg-[#b8f6b7]",
                        image: "png-to-pdf.png",
                        handleFileUpload: handleFileUpload,
                        acceptFiles: "image/*"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "preview-pdfs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-[1280px] mx-auto flex flex-col gap-14 justify-center items-center mt-12 sm:mt-20 px-4 sm:px-8",
                        children: [
                            images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        className: "text-3xl font-light text-center text-gray-700",
                                        children: [
                                            "Remove the image which you ",
                                            "don't",
                                            " want"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: ()=>setImages([]),
                                            className: "bg-violet-600 mx-auto w-full sm:w-[190px] py-2 text-xl rounded-lg font-semibold text-white flex items-center justify-center gap-4 hover:bg-violet-400",
                                            children: "Remove All"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative w-full h-[400px] flex flex-wrap justify-center gap-4 border-2 md:px-10 py-4 md:py-14 md:rounded-xl overflow-y-scroll scrollbar-thin scrollbar-thumb-violet-500 scrollbar-rounded-[12px]",
                                        children: [
                                            images.map((image, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "border w-fit relative flex justify-center items-center flex-wrap",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "p-4 bg-white w-[250px]",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                id: "image-generated",
                                                                src: image,
                                                                alt: "pdfImage",
                                                                className: "w-full"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute top-2 left-2 w-8 h-8 bg-black rounded-full text-xl text-white flex justify-center items-center cursor-pointer",
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            onClick: ()=>removeImage(index),
                                                            className: "absolute top-2 right-2 w-8 h-8 bg-gray-400 rounded-full flex justify-center items-center cursor-pointer",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_17__/* .AiOutlineClose */ .oHP, {
                                                                className: "text-white text-xl"
                                                            })
                                                        })
                                                    ]
                                                }, index)),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                id: "page-loader",
                                                className: "".concat(pageRendering ? "absolute w-full top-0 left-0 h-full flex justify-center items-center bg-white z-50" : "hidden"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    "aria-hidden": "true",
                                                    class: "w-14 h-14 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-violet-600",
                                                    viewBox: "0 0 100 101",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                            fill: "currentColor"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                            fill: "currentFill"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                id: "split-pdfs",
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-10 flex flex-col justify-center items-center gap-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-center items-center gap-4 flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-gray-600 text-lg",
                                                            children: "Page Size : "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                            onChange: (e)=>setPageSize(e.target.value),
                                                            className: "bg-white text-violet-600 outline-none w-fit p-2 rounded-lg shadow-md border border-violet-500",
                                                            value: pageSize,
                                                            name: "",
                                                            id: "",
                                                            children: PAGE_SIZES.map((size, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: size,
                                                                    children: size
                                                                }, index))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "text-gray-600 text-lg",
                                                            children: [
                                                                "Orientation :",
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                            onChange: (e)=>setOrientation(e.target.value),
                                                            className: "bg-white text-violet-600 outline-none w-fit p-2 rounded-lg shadow-md border border-violet-500",
                                                            value: orientation,
                                                            name: "",
                                                            id: "",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "portrait",
                                                                    children: "Portrait"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "landscape",
                                                                    children: "Landscape"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "text-gray-600 text-lg",
                                                            children: [
                                                                "Image Align :",
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                            onChange: (e)=>setImageAlignment(e.target.value),
                                                            className: "bg-white text-violet-600 outline-none w-fit p-2 rounded-lg shadow-md border border-violet-500",
                                                            value: imageAlignment,
                                                            name: "",
                                                            id: "",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "flex-start",
                                                                    children: "Top"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "center",
                                                                    children: "Center"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: "flex-end",
                                                                    children: "Bottom"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: handleDownload,
                                        className: "bg-[#d5f6d5] mx-auto w-full sm:w-[350px] py-4 text-xl rounded-lg font-semibold text-gray-900 flex items-center justify-center gap-4 hover:opacity-90 border-2 border-gray-900",
                                        children: loader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "flex items-center text-gray-900 space-x-2 ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_18___default().loader)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "",
                                                    children: "Downloading"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Download Pdf ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_19__/* .FaDownload */ .aBF, {
                                                    className: "text-3xl"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full px-4 sm:px-8 mt-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_Steps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            heading: "How to Convert PNG to PDF?",
                            steps: steps
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_WhyChooseBolosign__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            heading: "Features of BoloSign's PNG to PDF Converter",
                            description: "Our platform is designed with simplicity in mind, making it easy for anyone to convert PNG to PDF without any technical expertise. Also, we prioritize your privacy and data protection by processing and storing your documents securely.",
                            reasons: reasons
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_PricingCards__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            heading: "Looking for more than PDF tools?",
                            description: "Join 50,000+ teams who are already signing and accelerating their document workflow with BoloSign."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_TryBolosign__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            heading: "Try BoloSign Free for 7 Days!",
                            bgColor: "bg-[#d5f6d5]"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_OtherPdfTools__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            heading: "Other PDF Editing Tools",
                            description: "Free online PDF tools to merge, split, rotate, compress, convert, and many more.\nManage your daily PDF tasks with our online PDF tools."
                        })
                    }),
                    signaturePopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        onPopupClose: ()=>setSignaturePopup(false),
                        source: "PNG_TO_PDF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32 flex flex-col gap-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-center font-bold leading-[45px] sm:leading-[55px] lg:leading-[70px] text-[36px] sm:text-[48px] lg:text-[60px]",
                                children: "Frequently Asked Questions"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "max-w-screen-lg mx-auto w-full flex flex-col gap-6",
                                children: faqData.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        faqQuestion: faq.faqQuestion,
                                        faqAnswer: faq.faqAnswer
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PngToPdf);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,7627,6158,9570,1111,4186,1445,5999,1717,3758,8943,5726,4599,2145,9774,2888,179], function() { return __webpack_exec__(9878); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);